import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Download } from '@mui/icons-material';
import { FormControl, InputLabel, Select, Box, SelectChangeEvent } from '@mui/material';
import { User } from 'oidc-client';
import endpoints from '../constants/endpoints';
import useAuth from '../hooks/useAuth';
import useApiRequest from '../services/apiRequest';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import { useContext } from 'react';


export default function DownloadMenu() {
  const { post, queryStringConverter } = useApiRequest();
  const { userPermissions } = useContext(GlobalStateContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { description, filters, searchType: search_type, setOpenReportsDialog } = React.useContext(GlobalStateContext);
  const { getUser } = useAuth();
  const {currentUser, setCurrentUser}= React.useContext(GlobalStateContext);

  const [formato, setFormato] = React.useState('');

  const loadUser = async () => {
    let u: User | null = null;
    if (localStorage.getItem("user")) {
      u = JSON.parse(localStorage.getItem("user") || "") as User;
    } else {
      u = await getUser();
    }

    if (u)
      setCurrentUser(u);
  }

  React.useEffect(() => {
    loadUser();
  }, [])


  const handleChangeFormato = (event: SelectChangeEvent) => {
    setFormato(event.target.value as string);
  };


  const print = async () => {
    try {
      if (formato !== "") {
        const endpoint = `${endpoints.GENERATE_FILE}${queryStringConverter({
          search_type: search_type,
          total: 10000,
          file_type: formato,
          user: currentUser?.profile.username
        })}`;

        await post(endpoint, { description, ...filters });

        handleClose();
        setOpenReportsDialog(true);
        
      }
    } catch (error) {
      handleClose();
    }

  };

  return (
    <div>
      <Button
        disabled={!userPermissions.generate_file}
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant='contained'
        startIcon={<Download />}
      >
        Exportar
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{width:2000 }}
      >
        <Box sx={{display: 'flex', flexDirection: 'column', p:1}}>

          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label">Formato</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={formato}
              label="Formato"
              onChange={handleChangeFormato}
              required
              sx={{minWidth:200}}
            >
              <MenuItem value={'csv'}>CSV</MenuItem>
              <MenuItem value={'xlsx'}>XLSX</MenuItem>

            </Select>

          </FormControl>

          <Box sx={{ display: 'flex', mt: 2, width: '100%' }}>
              <Button variant='contained' sx={{ml:18}} onClick={print} size='large'>Ok</Button>
          </Box>


        </Box>

      </Menu>
    </div>
  );
}